import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters, commonFiltersValue, isSystemBusy } from '@signals'
import { BACKEND_APIS } from '@constants'
import { bannersDetailsHasLimit, bannersDetailsIsEmpty } from "../@signals";


export default function useBannersDetailsFilters() {

    const data = useSignal([])

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            postSubmit(`${BACKEND_APIS.BANNERS}/details/wrapped/context`, commonFiltersValue.value)
                .then(res => {
                    if (!res.data?.length)
                        bannersDetailsIsEmpty.value = true
                    data.value = res.data
                    bannersDetailsHasLimit.value = res.hasLimit
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value,
    }
}
